/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React from 'react';
import TextInput from 'components/TextInput/TextInput.react';
import Button from 'components/Button/Button.react';
import styles from 'components/InlineSubmitInput/InlineSubmitInput.scss';

export default class InlineSubmitInput extends React.Component {
  constructor(props) {
    super();

    this.state = {
      value: '',
      showButton: false,
    };
  }

  handleInputChange(value) {
    const { onChange } = this.props;
    if (onChange) {
      onChange(value);
    }

    this.setState({ value, showButton: this.validate(value) });
  }

  handleSubmit() {
    this.props.onSubmit(this.state.value).then((shouldClearInput) => {
      if (shouldClearInput) {
        this.handleInputChange('');
      }
    });
  }

  validate(value) {
    if (this.props.validate) {
      return this.props.validate(value);
    }
    return value.length > 0;
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.input}>
          <TextInput
            placeholder={this.props.placeholder}
            value={this.state.value}
            onChange={this.handleInputChange.bind(this)} />
        </div>
        <div className={styles.button}>
          <Button
            color="green"
            disabled={!this.state.showButton}
            value={this.props.submitButtonText}
            onClick={this.handleSubmit.bind(this)} />
        </div>
      </div>
    );
  }
}

InlineSubmitInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitButtonText: PropTypes.string.isRequired,
  validate: PropTypes.func,
  placeholder: PropTypes.string,
};
